import styled from 'styled-components';

// CONSTANTS
import { WATERLOO } from '@/constants/colors';

export const CardContainer = styled.div`
  position: relative;

  a {
    display: flex;
    align-items: center;
  }

  .author {
    &__image {
      height: 34px;
      width: 34px;
      border-radius: 50%;
      margin-right: 10px;
    }

    &__name,
    &__date {
      font-weight: 600;
      font-size: 1.2rem;
      line-height: 1.2rem;
    }

    &__name {
      margin-bottom: 5px;
    }

    &__date {
      color: ${WATERLOO};
    }
  }
`;

export default CardContainer;
